// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

import { EstimateCategory } from '../../../gql/graphql';

const estimateKeys = {
  all: ['estimate'] as const,
  estimateDefaultItems: (category: EstimateCategory) =>
    [...estimateKeys.all, 'estimateDefaultItems', category] as const,
  estimatePreviews: () => [...estimateKeys.all, 'estimatePreview'] as const,
  estimatePreview: (estimateId: string | undefined) =>
    [...estimateKeys.estimatePreviews(), estimateId] as const,
  emailPreviews: () => [...estimateKeys.all, 'emailPreview'] as const,
  emailPreview: (estimateId: string | undefined) =>
    [...estimateKeys.emailPreviews(), estimateId] as const,
};

export default estimateKeys;
